import $ from "jquery";
import hindi from "../Common/hindi";
import gujarat from "../Common/gujarat";
import marathi from "../Common/marathi";
import kannada from "../Common/kannada";
import malayalam from "../Common/malayalam";
import telugu from "../Common/telugu";
import tamil from "../Common/tamil";
import punjabi from "../Common/punjabi";
import assamese from "../Common/assamese";
import odia from "../Common/odia";
import bengali from "../Common/bengali";

export const twitterShareLink = "https://twitter.com/intent/tweet?text=";
export const facebookShareLink =
  "https://www.facebook.com/dialog/feed?app_id=5656793821114956";
export const whatsappShareLink = "https://api.whatsapp.com/send?text=";
export const WEB_BASE_URL =
  "https://www.narendramodi.in/selfiecampaignmahilalabharthi/detail/";

let env = "live";
// let env = "stage";

let Link = "https://membership.bjp.org/";

if (env === "stage") {
  Link = "https://pmdrive-stage.bjp.org/";
}
// export const produrl = "https://prod-pm-drive.bjp.org/";
// export const produrl = "https://staging-pm-drive.bjp.org/";
// export const stageurl = "https://pmdrive-stage.bjp.org/";
export const produrl = Link;

export const fetchSignedPhotoUrl = async (type = "profile") => {
  const token = localStorage.getItem("acesss");
  if (!token) return null;

  try {
    const response = await fetch(
      `${produrl}api/v1/photo/url?type=${encodeURIComponent(type)}`,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
      }
    );
    if (!response.ok) return null;
    const data = await response.json();
    return data && data.url ? data.url : null;
  } catch (err) {
    console.error("fetchSignedPhotoUrl:", err);
    return null;
  }
};

export const getParameterByName = async (name, url) => {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

export const dataURLToBlob = function (dataURL) {
  var BASE64_MARKER = ";base64,";
  var parts = "";
  var contentType = "";
  var raw = "";
  if (dataURL.indexOf(BASE64_MARKER) === -1) {
    parts = dataURL.split(",");
    contentType = parts[0].split(":")[1];
    raw = parts[1];
    return new Blob([raw], { type: contentType });
  }
  parts = dataURL.split(BASE64_MARKER);
  contentType = parts[0].split(":")[1];
  raw = window.atob(parts[1]);
  var rawLength = raw.length;
  var uInt8Array = new Uint8Array(rawLength);

  for (var i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }

  return new Blob([uInt8Array], { type: contentType });
};

export const checkMobile = () => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  if (isMobile) {
    return "mobile";
  } else {
    return "desktop";
  }
};

export const appShareTextString = (text) => {
  // text = text ? text.split("'").join("") : "";
  text = text ? text.split("‘").join("'") : "";
  text = text ? text.split("’").join("'") : "";
  text = text ? text.split("‟").join('"') : "";
  text = text ? text.split("“").join('"') : "";
  text = text ? text.split("❝").join('"') : "";
  text = text ? text.split("❞").join('"') : "";
  text = text ? text.split("”").join('"') : "";
  text = text ? text.split("„").join('"') : "";
  return text;
};

export const apiUrl = "https://campaign-api.narendramodi.in/";
export const apiUrlRDS = "https://campaign-api.narendramodi.in/mahila-rds";

export const doRequest = (payload, sync, urlType = "default") => {
  var data = JSON.stringify(payload);
  var xhr = new XMLHttpRequest();
  let url = urlType === "RDS" ? apiUrlRDS : apiUrl + "membership_2024";
  xhr.open("POST", url, sync);
  xhr.send(data);
  return xhr;
};

export const parseURLParams = (url) => {
  var queryStart = url.indexOf("?") + 1,
    queryEnd = url.indexOf("#") + 1 || url.length + 1,
    query = url.slice(queryStart, queryEnd - 1),
    pairs = query.replace(/\+/g, " ").split("&"),
    parms = {},
    i,
    n,
    v,
    nv;

  if (query === url || query === "") return;

  for (i = 0; i < pairs.length; i++) {
    nv = pairs[i].split("=", 2);
    n = decodeURIComponent(nv[0]);
    v = decodeURIComponent(nv[1]);

    if (!parms.hasOwnProperty(n)) parms[n] = [];
    parms[n].push(nv.length === 2 ? v : null);
  }
  return parms;
};

export const textMapping = (text) => {
  let lang = "";
  // var url_string = window.location.href; //window.location.href
  // var url = new URL(url_string);
  // var langurl = url.searchParams.get("lang");
  var langurl = localStorage.getItem("language");
  try {
    lang =
      langurl === "gu"
        ? "gu"
        : langurl === "hi"
        ? "hi"
        : langurl === "be"
        ? "be"
        : langurl === "ka"
        ? "ka"
        : langurl === "ma"
        ? "ma"
        : langurl === "mar"
        ? "mar"
        : langurl === "od"
        ? "od"
        : langurl === "ta"
        ? "ta"
        : langurl === "te"
        ? "te"
        : langurl === "man"
        ? "man"
        : langurl === "pu"
        ? "pu"
        : langurl === "asm"
        ? "asm"
        : langurl === "ur"
        ? "ur"
        : "en";
  } catch (error) {}
  if (lang && lang == "hi") {
    if (hindi[text]) {
      return hindi[text];
    } else {
      return text;
    }
  } else if (lang && lang == "gu") {
    if (gujarat[text]) {
      return gujarat[text];
    } else {
      return text;
    }
  } else if (lang && lang == "mar") {
    if (marathi[text]) {
      return marathi[text];
    } else {
      return text;
    }
  } else if (lang && lang == "ka") {
    if (kannada[text]) {
      return kannada[text];
    } else {
      return text;
    }
  } else if (lang && lang == "ma") {
    if (malayalam[text]) {
      return malayalam[text];
    } else {
      return text;
    }
  } else if (lang && lang == "te") {
    if (telugu[text]) {
      return telugu[text];
    } else {
      return text;
    }
  } else if (lang && lang == "ta") {
    if (tamil[text]) {
      return tamil[text];
    } else {
      return text;
    }
  } else if (lang && lang == "pu") {
    if (punjabi[text]) {
      return punjabi[text];
    } else {
      return text;
    }
  } else if (lang && lang == "asm") {
    if (assamese[text]) {
      return assamese[text];
    } else {
      return text;
    }
  } else if (lang && lang == "od") {
    if (odia[text]) {
      return odia[text];
    } else {
      return text;
    }
  } else if (lang && lang == "be") {
    if (bengali[text]) {
      return bengali[text];
    } else {
      return text;
    }
  } else {
    return text;
  }
};
